export function fmtPKT(iso, withSeconds = false) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const opts = {
    timeZone: "Asia/Karachi", year: "numeric", month: "short", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: true,
    ...(withSeconds ? { second: "2-digit", fractionalSecondDigits: 3 } : {}),
  };
  return new Intl.DateTimeFormat("en-GB", opts).format(d) + " PKT";
}

export function timePKT(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Karachi", hour: "2-digit", minute: "2-digit", hour12: true,
  }).format(d);
}
